import * as EducationConstants from './constants';
import * as D from './deps';

/**
 * Function to see if we have reached Premium Access Welcome Message limit
 *
 * @param {object} appState - current state of the application
 * @returns {boolean}
 */

export function getListenerEducationCount(state, reducerKey) {
  const listener = D.Utils.Listener.getCurrentListenerIdFromState(state);
  return state.education.getIn([EducationConstants.ReducerKeys.LISTENERS, listener, reducerKey], 0);
}

export function getPremiumAccessEducationWelcomeMessageCount(state) {
  return getListenerEducationCount(
    state,
    EducationConstants.ReducerKeys.PREMIUM_ACCESS_EDUCATION_WELCOME_MESSAGE_COUNT,
  );
}

export function getPremiumAccessEducationExitMessageCount(state) {
  return getListenerEducationCount(
    state,
    EducationConstants.ReducerKeys.PREMIUM_ACCESS_EDUCATION_EXIT_MESSAGE_COUNT,
  );
}

export function reachedPremiumAccessEducationExitMessageLimit(state) {
  const count = getPremiumAccessEducationExitMessageCount(state);
  return (
    count >=
    EducationConstants.PremiumAccessEducationConstants.PREMIUM_ACCESS_EDUCATION_EXIT_MESSAGE_LIMIT
  );
}

export function watchForMtupPlaylistUnlock(state) {
  return state.education.getIn([EducationConstants.ReducerKeys.WATCH_FOR_MTUP_PLAYLIST_UNLOCK]);
}

export function mtupPlaylistReadyForMiniCoachmark(state) {
  return state.education.getIn([
    EducationConstants.ReducerKeys.MTUP_PLAYLIST_READY_FOR_MINICOACHMARK,
  ]);
}

export function getPodcastFeedbackCount(state) {
  return getListenerEducationCount(
    state,
    EducationConstants.ReducerKeys.PODCAST_POSITIVE_FEEDBACK_COUNT,
  );
}
